import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { distinctUntilChanged, Observable, shareReplay } from 'rxjs';
import { environment } from '../../environments/environment';
import { JobPlatform } from '../interfaces/job-platform';
import { MultipostingProvider } from '../enums/multiposting-provider.enum';
@Injectable({
  providedIn: 'root',
})
export class JobPlatformsAdapter {
  private http = inject(HttpClient);

  getJobPlatforms(
    page: number,
    limit: number,
    query: string,
    currency?: string,
    jobTitleId?: string,
    industryId?: string,
    locationId?: string,
    language?: string
  ): Observable<{ platforms: JobPlatform[]; count: number; vat: number }> {
    const offset = (page - 1) * limit;
    const params = new HttpParams()
      .set('offset', offset.toString())
      .set('limit', limit.toString())
      .set('name', query ?? '')
      .set('currency', currency ?? '')
      .set('jobTitleId', jobTitleId ?? '')
      .set('industryId', industryId ?? '')
      .set('locationId', locationId ?? '')
      .set('language', language ?? '');

    return this.http
      .get<{
        platforms: JobPlatform[];
        count: number;
        vat: number;
      }>(`${environment.apiBaseUrl}/company/job-platforms`, { params })
      .pipe(shareReplay(1));
  }

  getDefaultJobPlatforms(
    currency?: string,
    jobTitleId?: string,
    industryId?: string,
    locationId?: string,
    language?: string
  ): Observable<{ platforms: JobPlatform[]; vat: number }> {
    const params = new HttpParams()
      .set('currency', currency ?? '')
      .set('jobTitleId', jobTitleId ?? '')
      .set('industryId', industryId ?? '')
      .set('locationId', locationId ?? '')
      .set('language', language ?? '');
    return this.http
      .get<{
        platforms: JobPlatform[];
        vat: number;
      }>(`${environment.apiBaseUrl}/company/default-job-platforms`, { params })
      .pipe(shareReplay(1));
  }

  getRecommendedJobPlatforms(
    currency?: string,
    jobTitleId?: string,
    industryId?: string,
    locationId?: string,
    language?: string
  ): Observable<{ platforms: JobPlatform[]; vat: number }> {
    const params = new HttpParams()
      .set('currency', currency ?? '')
      .set('jobTitleId', jobTitleId ?? '')
      .set('industryId', industryId ?? '')
      .set('locationId', locationId ?? '')
      .set('language', language ?? '');
    return this.http
      .get<{
        platforms: JobPlatform[];
        vat: number;
      }>(`${environment.apiBaseUrl}/company/recommended-job-platforms`, { params })
      .pipe(distinctUntilChanged(), shareReplay(1));
  }

  getSpecificJobPlatforms(
    platforms: { id: string; provider: MultipostingProvider }[]
  ): Observable<{ platforms: JobPlatform[] }> {
    const params = new HttpParams().set('platforms', JSON.stringify(platforms));
    return this.http
      .get<{ platforms: JobPlatform[] }>(`${environment.apiBaseUrl}/company/specific-job-platforms`, { params })
      .pipe(shareReplay(1));
  }
}
